export default __webpack_public_path__ + "static/media/play-icon.08f88255.svg";